import {
  GET_PRODUCT_INVENTORY_DATA,
  GET_SKU_INVENTORY_DATA,
  RESET_REDUX_STATE,
  GET_INVENTORY_ALL_COUNT,
  GET_INVENTORY_SKU_TABLE_LAYOUT,
  GET_INVENTORY_PRODUCT_TABLE_LAYOUT,
  CLEAR_INVENTORY_TABLE_LAYOUT
} from "../constants";

const initialValue = {
  productInventoryData: [],
  skuInventoryData: [],
  inventoryAllCount: "",
  inventorySkuTableLayout: [],
  inventoryProductTableLayout: []
};

const inventory = (state = initialValue, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PRODUCT_INVENTORY_DATA: {
      return {
        ...state,
        productInventoryData: payload,
      };
    }

    case GET_SKU_INVENTORY_DATA: {
      return {
        ...state,
        skuInventoryData: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return initialValue;
    }

    case GET_INVENTORY_ALL_COUNT: {
      return {
        ...state,
        inventoryAllCount: payload,
      };
    }

    case GET_INVENTORY_SKU_TABLE_LAYOUT: {
        return {
            ...state,
            inventorySkuTableLayout: payload
        }
    }

    case GET_INVENTORY_PRODUCT_TABLE_LAYOUT: {
        return {
            ...state,
            inventoryProductTableLayout: payload
        }
    }

    default:
      return state;
  }
};

export default inventory;
